var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 24,
    viewBox: "0 0 117 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_26_63)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 97.0002,
    y: 2,
    width: 20,
    height: 20,
    rx: 5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.564 5L103 6.56355L108.079 11.6534L103 16.7433L104.564 18.3068L111.217 11.6534L104.564 5Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65325 18.3066L8.2168 16.7431L3.13803 11.6532L8.2168 6.56339L6.65325 4.99984L-0.000153 11.6532L6.65325 18.3066Z",
    fill: "#4D4D4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.224 7.44V18H22.992V8.816L20.272 10.608L19.712 9.68L23.072 7.44H24.224Z",
    fill: "#2DA5FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.856 18H39.104V16.96L42.192 13.712C42.7253 13.1573 43.1147 12.736 43.36 12.448C43.6053 12.16 43.824 11.8187 44.016 11.424C44.2187 11.0293 44.32 10.6347 44.32 10.24C44.32 9.55733 44.1333 9.07733 43.76 8.8C43.3867 8.52267 42.8053 8.384 42.016 8.384C41.3227 8.384 40.5493 8.47467 39.696 8.656L39.28 8.736L39.184 7.712C40.1973 7.424 41.2427 7.28 42.32 7.28C43.3973 7.28 44.208 7.50933 44.752 7.968C45.3067 8.416 45.584 9.13067 45.584 10.112C45.584 10.8587 45.4187 11.5093 45.088 12.064C44.7573 12.6187 44.1867 13.2853 43.376 14.064L40.56 16.928H45.856V18Z",
    fill: "#CBCBCB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1522 7.712C60.1549 7.41333 61.2269 7.264 62.3682 7.264C63.5202 7.264 64.3522 7.48267 64.8642 7.92C65.3762 8.35733 65.6322 9.056 65.6322 10.016C65.6322 10.5067 65.5629 10.864 65.4242 11.088C65.2962 11.3013 65.1896 11.4667 65.1042 11.584C65.0296 11.7013 64.9282 11.8133 64.8002 11.92C64.5656 12.1013 64.3789 12.2293 64.2402 12.304L64.0642 12.416C64.6829 12.64 65.1416 12.928 65.4402 13.28C65.7389 13.6213 65.8882 14.1867 65.8882 14.976C65.8882 16.0533 65.6109 16.8533 65.0562 17.376C64.5122 17.8987 63.6482 18.16 62.4642 18.16C61.5256 18.16 60.5336 18.0533 59.4882 17.84L58.9922 17.728L59.1042 16.72C60.2562 16.9547 61.3336 17.072 62.3362 17.072C63.8616 17.0613 64.6242 16.3787 64.6242 15.024C64.6242 13.7547 63.8989 13.0933 62.4482 13.04H60.3202V11.984H62.4482C62.8962 11.984 63.3282 11.808 63.7442 11.456C64.1602 11.0933 64.3682 10.6187 64.3682 10.032C64.3682 9.44533 64.2029 9.024 63.8722 8.768C63.5416 8.50133 62.9869 8.368 62.2082 8.368C61.3549 8.368 60.5122 8.448 59.6802 8.608L59.2642 8.688L59.1522 7.712Z",
    fill: "#CBCBCB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7602 18V15.936H78.6402V14.976L81.6482 7.44H82.9922L79.9362 14.848H83.7602V11.552H84.9922V14.848H86.3362V15.936H84.9922V18H83.7602Z",
    fill: "#CBCBCB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_26_63",
    x: 97.0002,
    y: 2,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26_63"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter);
export default __webpack_public_path__ + "static/media/footer.917f92e8405c5ccb358f52a7863316cc.svg";
export { ForwardRef as ReactComponent };